import Image from "next/image";
import React from "react";

function BgButton({
  children,
  className,
  activeTextColor = "#fff",
  activeBg,
  ...props
}: BgButtonPropsType) {
  return (
    <button
      type="button"
      className={`relative overflow-hidden items-center justify-center  group hover:opacity-90  inline-flex 
         hover:text-white  font-medium rounded-[10px] text-[14px] lg:text-[1.25rem]
         min-h-[48px] min-w-[48px] lg:min-h-[56px] lg:min-w-[56px]
         px-[4.4rem] py-[0.70rem] focus:outline-none bg-[#ff000000] text-primary border-solid border-2   border-primary ${className}`}
      {...props}
    >
      <span> {children}</span>
      <div
        className="absolute left-1/2 top-1/2  bottom-0 -z-10 bg-primary   transition-all   ease-in-out duration-200 w-0 h-0 group-hover:left-0 group-hover:top-0  group-hover:w-full group-hover:h-full"
        style={{ background: activeBg }}
      ></div>

      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="15.109"
        height="8.377"
        viewBox="0 0 15.109 8.377"
        className={`absolute rotate-90 rtl:rotate-[-90deg] end-[6.25rem] group-hover:end-[2.93rem] w-0 group-hover:w-[1.1rem]   transition-all   ease-in-out duration-300 `}
      >
        <path
          id="Path_49625"
          data-name="Path 49625"
          d="M-14235-22930l5.834,5.359,5.742-5.359"
          transform="translate(-14221.657 -22923.391) rotate(180)"
          fill="none"
          stroke={activeTextColor}
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2.5"
        />
      </svg>
    </button>
  );
}

export default BgButton;
type BgButtonPropsType = React.DetailedHTMLProps<
  React.ButtonHTMLAttributes<HTMLButtonElement>,
  HTMLButtonElement
> & {
  activeBg?: string;
  activeTextColor?: string;
};
